"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const FieldItem_vue_1 = __importDefault(require("./FieldItem.vue"));
const EBecropController_1 = __importDefault(require("../Types/EBecropController"));
const ViewZeroFieldList_vue_1 = __importDefault(require("./ViewZeroFieldList.vue"));
let FieldList = class FieldList extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.fieldsList = this.fields;
    }
    fieldItemAction(newCurrentField) {
        this.setCurrentField(newCurrentField);
        if (newCurrentField.recSet.recommendations.length < 1 && this.hasEbecropDiagnosticPassed(newCurrentField) && newCurrentField.recomendationsBrief === 'has_recommendations') {
            this.eBecropController.expandOrderPanel();
        }
        else {
            this.eBecropController.disabledOrderPanel();
        }
    }
    hasEbecropDiagnosticPassed(field) {
        if (!field.eBeCropDiagnostic.acreage)
            return false;
        if (!field.eBeCropDiagnostic.region)
            return false;
        if (!field.eBeCropDiagnostic.crop)
            return false;
        return true;
    }
    setCurrentField(newCurrentField) {
        if (this.eBecropController.currentField === newCurrentField) {
            this.eBecropController.currentField = null;
        }
        else {
            this.eBecropController.setCurrentField(newCurrentField);
        }
    }
    filterFields(filter) {
        if (filter.length > 0) {
            this.fieldsList = [];
            this.fieldsList = this.eBecropController.findFieldsClient(filter);
        }
        else {
            this.fieldsList = this.fields;
        }
    }
    handleScroll() {
        const container = this.$refs.scrollContainer;
        let currentPage = this.eBecropController.currentPageFields.page;
        if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
            currentPage++;
            // console.log('Get new fields page: ', currentPage)
            if (currentPage < this.eBecropController.numClientPages) {
                this.eBecropController.getStoredFields(currentPage);
            }
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], FieldList.prototype, "fields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new EBecropController_1.default() })
], FieldList.prototype, "eBecropController", void 0);
FieldList = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Search: bmk_ui_framework_1.Search, FieldItem: FieldItem_vue_1.default, Loading: bmk_ui_framework_1.Loading, ViewZeroFieldList: ViewZeroFieldList_vue_1.default, ViewZero: bmk_ui_framework_1.ViewZero }
    })
], FieldList);
exports.default = FieldList;
